import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {deleteLocation} from "../../../../modules/location/locationListSlice";
import {useNavigate} from "react-router-dom";
import {showErrorToastNotification, showInfoToastNotification, showSuccessToastNotification} from "../../../toastNotification/toastNotificationSlice";

interface ConfirmationModalProps {
    publicId: string
    handleClose: (value?: any) => any
    onClickRedirectPath?: string
    entityName?: string
}

export const DeleteLocationConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                      publicId,
                                                                                      handleClose,
                                                                                      onClickRedirectPath,
                                                                                      entityName
                                                                                  }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDelete = async () => {
        handleClose()
        if (onClickRedirectPath) {
            navigate(onClickRedirectPath)
        }
        dispatch(showInfoToastNotification({message: "Deleting location. We'll notify you once it's done."}))
        try {
            await dispatch(deleteLocation(publicId)).unwrap()
            dispatch(showSuccessToastNotification({message: "Location deleted successfully"}))
        } catch {
            dispatch(showErrorToastNotification({message: "Failed to delete the location. Please try again."}))
        }
    }

    return <ConfirmationModal
        title={"Delete the location"}
        subtitle={"Are you sure you want to delete this location? You won't be able to undo this action."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
        confirmationText={entityName}
    />
}
